import * as yup from 'yup';
import { dynamicUnitName } from 'components/units/UnitDefinitionsAndMasks';

export default function validationSchema(t, alcoholUnitRelateds) {
  const validationPhrases = {
    tavValidationPhrase: t('validations.tav_validation', {
      tavMin: alcoholUnitRelateds.tavMin,
      tavMax: alcoholUnitRelateds.tavMax,
      alcoholUnit: dynamicUnitName(alcoholUnitRelateds.alcoholUnit),
    }),
    tempValidationPhrase: t('validations.temperature_validation', {
      tempMin: alcoholUnitRelateds.tempMin,
      tempMax: alcoholUnitRelateds.tempMax,
      tempUnit: dynamicUnitName(alcoholUnitRelateds.tempUnit),
    }),
  };

  const measuredTavExp = /^\d+([.]\d{1,2})?$/;
  const measuredTempExp = /^\d+([.]\d{1,2})?$/;

  return yup.object().shape({
    measuredTav: yup
      .number()
      .transform((value, originalValue) => (/\s/.test(originalValue) ? NaN : value))
      .typeError(validationPhrases.tavValidationPhrase)
      .required(validationPhrases.tavValidationPhrase)
      .min(alcoholUnitRelateds.tavMin, validationPhrases.tavValidationPhrase)
      .max(alcoholUnitRelateds.tavMax, validationPhrases.tavValidationPhrase)
      .test('nb-of-decimal', validationPhrases.tavValidationPhrase, (value) => (`${value}`).match(measuredTavExp)),
    measuredTemp: yup
      .number()
      .transform((value, originalValue) => (/\s/.test(originalValue) ? NaN : value))
      .typeError(validationPhrases.tempValidationPhrase)
      .required(validationPhrases.tempValidationPhrase)
      .min(alcoholUnitRelateds.tempMin, validationPhrases.tempValidationPhrase)
      .max(alcoholUnitRelateds.tempMax, validationPhrases.tempValidationPhrase)
      .test('nb-of-decimal', validationPhrases.tempValidationPhrase, (value) => (`${value}`).match(measuredTempExp)),
    measuredTAVTemp: yup
      .number()
      .transform((value, originalValue) => (/\s/.test(originalValue) ? NaN : value))
      .typeError(validationPhrases.tempValidationPhrase)
      .required(validationPhrases.tempValidationPhrase)
      .min(alcoholUnitRelateds.tempMin, validationPhrases.tempValidationPhrase)
      .max(alcoholUnitRelateds.tempMax, validationPhrases.tempValidationPhrase)
      .test('nb-of-decimal', validationPhrases.tempValidationPhrase, (value) => (`${value}`).match(measuredTempExp)),
  });
}
